import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import useToggle from "../../hooks/useToggle";
import { RootState } from "../../store/store";
import CommonComponents from "../Commons";
import MenuItem from "./MenuItem";

import { Divider } from "antd";
import { useTranslation } from "react-i18next";
import { showSuccess } from "../../helpers/toast";
import { changeVisibleListApp } from "../../store/reducers/appCommonSlice";
import { renderIcon } from "../../utils/ultis";
import DefaultLogo from '../../assets/svg/default-logo.svg';
import { resolveDynamicProps } from "./ultis";

export default function MenuBar()
{
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { expanded } = useSelector((state: RootState) => state.layoutSlice);
  const publicConfig = useSelector(
    (state: RootState) => state.appCommonSlice.publicConfig,
  );
  const visibleListApp = useSelector(
    (state: RootState) => state.appCommonSlice.visibleListApp,
  );
  const { arrIdImage } = useSelector((state: RootState) => state.cartSlice);


  const totalNoti = useSelector(
    (state: RootState) => state.notificationSlice.total,
  );
  const roleUsing = useSelector(
    (state: RootState) => state.appCommonSlice.roleUsing,
  );
  const dataMenu = useSelector(
    (state: RootState) => state.layoutSlice.sideMenuConfig,
  );
  const dataBottomMenu = useSelector(
    (state: RootState) => state.layoutSlice.sideBottomMenuConfig,
  );

  const commonSytem = useSelector(
    (state: RootState) => state.appCommonSlice.commonSystem,
  );

  const [activeKey, setActiveKey] = useState<any>(null);

  const {
    open: openConfirmLogout,
    shouldRender: shouldRenderConfirmLogout,
    toggle: toggleConfirmLogout,
  } = useToggle();

  const currentRole = "user";

  const filterMenuByRole = (items: any[], role: string) =>
    items?.filter((item) => !item?.role || item?.role.includes(role));

  const ONCLICK_ROUTE_MAP: Record<string, string> = {
    handleClickMenuCart: "/cart",
  };

  const handleClickMenuCart = () =>
  {
    navigate('/cart')
  };

  const handleClickMenuLogout = () =>
  {
    toggleConfirmLogout();
  };

  const ON_CLICK_HANDLERS: Record<string, () => void> = {
    handleClickMenuCart,
    handleClickMenuLogout,
  };

  const calculateActiveKey = () =>
  {
    const menus = filterMenuByRole(
      dataMenu?.menu?.[0]?.items?.filter((itemF: any) => itemF?.active) || [],
      currentRole,
    );
    const bottomMenus = filterMenuByRole(
      dataBottomMenu?.menu?.[0]?.items?.filter((itemF: any) => itemF?.active) ||
      [],
      currentRole,
    );
    const allMenus = [...menus, ...bottomMenus];

    const matchItem = allMenus.find((item) =>
    {
      if (item?.route) return location.pathname.startsWith(item.route);
      if (item?.onClick && ONCLICK_ROUTE_MAP[item.onClick])
        return location.pathname.startsWith(ONCLICK_ROUTE_MAP[item.onClick]);
      return false;
    });

    return matchItem?.id || null;
  };

  const renderMenu = (menus: any[], offset: number = 0) =>
    filterMenuByRole(menus, currentRole)?.map((item: any, index: number) =>
    {
      if (item?.id === "divider")
      {
        return (
          <Divider
            className="bg-[var(--color-divider)]"
            key={`divider-${index}`}
            style={{ margin: "10px 0" }}
          />
        );
      }

      const context = { totalNoti, arrIdImage, publicConfig };
      const keysToResolve = ["total", "acrossUrl"];
      const itemResolved = resolveDynamicProps(item, keysToResolve, context);

      return (
        <MenuItem
          key={item?.id}
          icon={renderIcon(item?.icon?.type, item?.icon)}
          label={t(item?.label?.lang_key)}
          url={item?.route}
          activeKey={activeKey}
          indexKey={item?.id}
          setActiveKey={() =>
          {
            if (item?.route)
            {
              setActiveKey(item?.id);
            }
          }}
          tooltipMain={t(item?.label?.lang_key)}
          baseOnUrl={false}
          total={itemResolved?.total}
          acrossUrl={itemResolved?.acrossUrl}
          onClick={() =>
          {
            if (item?.onClick && ON_CLICK_HANDLERS[item.onClick])
            {
              ON_CLICK_HANDLERS[item.onClick]();
              setActiveKey(item?.id);
            } else if (item?.route)
            {
              navigate(item.route);
              setActiveKey(item?.id);
            } else if (item?.acrossUrl)
            {
              window.open(itemResolved?.acrossUrl);
            }
          }}
        />
      );
    });

  useEffect(() =>
  {
    const activeIndex = calculateActiveKey();

    if (activeIndex !== null)
    {
      setActiveKey(activeIndex);
    } else
    {
      let data = filterMenuByRole(
        dataMenu?.menu?.[0]?.items || [],
        currentRole,
      );

      setActiveKey(data?.[0]?.id);
    }
  }, [location.pathname, dataMenu, dataBottomMenu, roleUsing]);



  return (
    <div
      className={`h-full flex flex-col sidebar ${expanded ? "w-[268px]" : "w-[84px]"}`}
      onClick={() => dispatch(changeVisibleListApp(false))}
    >
      <div
        className="flex-none flex mx-2 justify-center items-center h-[73px] cursor-pointer  bg-[var(--color-bg-div-logo)]"
        onClick={(e) =>
        {
          e.stopPropagation();
          dispatch(changeVisibleListApp(!visibleListApp));
        }}
      >
        {commonSytem?.logo ? (
          <>
            {renderIcon(
              commonSytem?.logo?.type,
              commonSytem?.logo,
              "!h-[40px] !w-[40px] !min-w-[40px]",
            )}
          </>
        ) : (
          <>
            <img
              src={DefaultLogo}
              className="!h-[40px] !w-[50px] !min-w-[50px]"
            />
          </>
        )}

        {expanded && (
          <div
            className="text-lg font-bold text-[var(--color-main-text)]"

          >
            {commonSytem?.titleApp ?? "VMRS"}
          </div>
        )}
      </div>

      <Divider
        className="bg-[var(--color-divider)]"
        style={{
          marginBottom: "10px",
          marginTop: "0",
        }}
      />

      <div className="grow flex flex-col justify-between px-4 pb-2">
        <div className="grow flex flex-col gap-2">
          {renderMenu(
            dataMenu?.menu?.[0]?.items?.filter((itemF: any) => itemF?.active) ||
            [],
          )}
        </div>

        <div className="flex flex-col gap-1">
          {renderMenu(
            dataBottomMenu?.menu?.[0]?.items?.filter(
              (itemF: any) => itemF?.active,
            ) || [],
            dataMenu?.menu?.[0]?.items?.filter((itemF: any) => itemF?.active)
              ?.length || 0,
          )}
        </div>
      </div>

      {shouldRenderConfirmLogout && (
        <CommonComponents.ModalUI
          open={openConfirmLogout}
          title={t("Logout")}
          toggle={toggleConfirmLogout}
          handleConfirm={() =>
          {
            localStorage.removeItem("token");
            localStorage.removeItem("key");
            localStorage.removeItem("token_type");
            navigate("/login");
            showSuccess(t("Logout successfully"));
            toggleConfirmLogout();
          }}
        >
          <p>{t("Are you sure you want to logout this session?")}</p>
        </CommonComponents.ModalUI>
      )}
    </div>
  );
}
